// extracted by mini-css-extract-plugin
module.exports = {"container":"e00aacc1","teachercards":"_98570762","teacher":"_07f78149","teacherimg":"_33ca08ce"};